export var DiscographyDataSet = [
    {
        'DataType': 'discography',
		'discographyID': 'HeroesofaWesternNight',
		'imageURL':'/media/discography/HeroesofaWesternNightAlbumArtwork-min.JPG',
		'WebsiteData': {
			'link':'https://leadfinder.app/',
		},
		'Externals': {
			'Listen on Spotify': 'https://open.spotify.com/track/3XNAxQAhUXDd4tMSsvcysG?si=d7ada59fe4264cc9',
            'Listen on Apple Music': 'https://music.apple.com/us/album/heroes-of-a-western-night-feat-cody-sherman/1787530273?i=1787530274',
		},
		'NavigationStyle': {
			'primaryColor': 'rgb(137,68,54, 0.7)',
			'secondaryColor': '#ffffff'
		}, 
		
		'ContentPageData': {
			'background': {
				'imageURL': '/media/discography/HeroesofaWesternNightAlbumArtwork-min.JPG',
				'color': 'rgb(164,134,100)'
			},
			'board': {
				'title': 'Heroes of a Western Night',
				'position': '',
				'type': '',
				'brief': '...tales of love and sweet romance',
				'story': `
				"Heroes of a Western Night" is an autobiographical love letter, written in conclusion to an important chapter of my life. I wanted to paint my experience of love and heartbreak against the backdrop of modern Western America. This was one of my very first original songs that I wrote. Upon completion, and for the first time, I felt a very genuine and intimate sense of satisfaction in the lyricism. Looking back, I can see the prematurity in my melodic choices. I was so excited to simply write something decent that I did not consider taking any wild chances with the structure of the tune. 
				Lyrically, Heroes of a Western Night follows two drifters — kindred spirits drawn together by the open road — where the desire to chase dreams crossroads with the hard truths of life. It’s a song about youthful love and the kind of moments that stay etched in your memory long after the fire dies down. I still love to listen back to this tune and let the memories of a past life run through my mind.
				
				`,
				'deliverables': ['Lyricist, producer, guitarist, pianist, vocalist '],
				'styles': {
					'buttonColor': 'rgba(0,0,0,0.3)',
					'buttonArrowColor': 'rgb(255,255,255)',
					'headerColor': '#ffffff',
					'backgroundColor': 'rgba(137,68,54,0.95)',
					'positionColor': '#ffffff',
					'titleColor': '#ffffff',
					'viewApplicationColor': '#ffffff',
					'typeColor':  '#ffffff',
					'briefColor': '#ffffff',
					'storyColor': '#ffffff',
					'skillColor': '#ffffff',
					'externalsColor': '#ffffff'
				}
				
			}
		}
	},
    {
		'DataType': 'discography',
		'discographyID': 'PuzzlePieceBlues',
		'imageURL':'/media/discography/puzzlepiecebluesalbumartwork-min.jpg',
		'WebsiteData': {
			'link':'https://leadfinder.app/',
		},
		'Externals': {
			'Listen on Spotify': 'https://open.spotify.com/track/1bjNOoaL01hRd1Iuad4hFK?si=8d614890262e4c37',
            'Listen on Apple Music': 'https://music.apple.com/us/album/puzzle-piece-blues-voice-memo/1776892538?i=1776892539',
		},
		'NavigationStyle': {
			'primaryColor': 'rgb(190,174,113, 0.7)',
			'secondaryColor': '#ffffff'
		}, 
		
		'ContentPageData': {
			'background': {
				'imageURL': '/media/discography/puzzlepiecebluesalbumartwork-min.jpg',
				'color': 'rgb(82,108,99)'
			},
			'board': {
				'title': 'Puzzle Piece Blues',
				'position': '',
				'type': '',
				'brief': 'Red, Orange, Yellow, Blue...',
				'story': `
				Puzzle Piece Blues is a personal favorite of mine. It was the first time I managed to get my thumb to pick a decent blues pattern while singing. Little accomplishments like these can mean the world, especially after long periods of creative drought. At the time, I was living in Indonesia, on the island of Lombok. While I was there, I came across a courageously gentle soul. Her presence was entirely reflective; without conscious effort, she inspired me to understand my own heart more deeply. As I spent more time with her, I realized how much I was actually discovering myself. I was reflecting on hidden pieces of my heart that had either been covered in dust or stashed away in some back closet for far too long.
				I wrote a number of songs during this period (Moonshine, Puzzle Piece Blues, Safe Place, Slowly Slowly, America). When writing this particular tune, the questions I asked myself were: Why have I always felt like I was missing a piece of myself? Am I able to love myself completely? If so, how would that change my life, my relationships, and my spirit?
				`,
				'deliverables': ['Lyricist, producer, guitarist, pianist, vocalist '],
				'styles': {
					'buttonColor': 'rgba(190,174,113,0.8)',
					'buttonArrowColor': 'rgb(255,255,255)',
					'headerColor': '#ffffff',
					'backgroundColor': 'rgba(84,113,89,0.95)',
					'positionColor': '#ffffff',
					'titleColor': '#ffffff',
					'viewApplicationColor': '#ffffff',
					'typeColor':  '#ffffff',
					'briefColor': '#ffffff',
					'storyColor': '#ffffff',
					'skillColor': '#ffffff',
					'externalsColor': '#ffffff'
				}
				
			}
		}
		
		
	},
    {
		'DataType': 'discography',
		'discographyID': 'MoonShine',
		'imageURL':'/media/discography/MoonShineAlbumArtwork-min.png',
		'WebsiteData': {
			'link':'https://leadfinder.app/',
		},
		'Externals': {
			'Listen on Spotify': 'https://open.spotify.com/track/6ZA7eWhQSZKfj8ruJqoNOu?si=7b745a09317f432e',
			'Listen on Apple Music': 'https://music.apple.com/us/album/moonshine-feat-cody-sherman-single/1799002529'
		},
		'NavigationStyle': {
			'primaryColor': 'rgb(81,75,107, 0.7)',
			'secondaryColor': '#ffffff'
		}, 
		
		'ContentPageData': {
			'background': {
				'imageURL': '/media/discography/MoonShineAlbumArtwork-min.png',
				'color': 'rgb(25,27,33)'
			},
			
			'board': {
				'title': 'Moonshine',
				'position': '',
				'type': '',
				'brief': 'You and I are a match made in heaven, quite a strange place for the devil to be selling',
				'story': `

				
				My grandparents met in the back of a police station wagon—tucked in the mountains of North Carolina. But not for the reason you might expect.

My grandfather was a preacher, as was his father before him. In those rural Appalachian hills, faith wasn’t just a belief—it was a lifeline. But not everyone saw it that way. Especially not the moonshine bootleggers whose livelihoods depended on secrecy. In their world, sermons and Sunday mornings posed a threat to business.

Moonshine is an unregulated, high-proof liquor brewed deep in the woods during the prohibition era. At 97 proof or higher, it could scorch your throat or even leave a man permanently blind if improperly distilled. The morals between bootleggers and preachers rarely aligned, and tensions ran high. So high, in fact, that my grandparents often needed a police escort just to get safely to church.

“Moonshine” tells the story of one of those mountain bootleggers. Laced with double meanings, vivid Southern imagery, and a blend of folk, blues, and alt-country soul, Moonshine is a story of desire, danger, and the kind of love that leaves a mark—even if it costs you your sight.

				
				“You and I, were a match made in heaven, quite a strange place for the devil to be selling”
				
				`,
				'deliverables': ['Lyricist, producer, guitarist, pianist, vocalist '],
				'styles': {
					'buttonColor': 'rgba(81,75,107,0.3)',
					'buttonArrowColor': 'rgb(255,255,255)',
					'headerColor': '#ffffff',
					'backgroundColor': 'rgba(25,27,33,0.95)',
					'positionColor': '#ffffff',
					'titleColor': '#ffffff',
					'viewApplicationColor': '#ffffff',
					'typeColor':  '#ffffff',
					'briefColor': '#ffffff',
					'storyColor': '#ffffff',
					'skillColor': '#ffffff',
					'externalsColor': '#ffffff'
				}
				
			}
		}
	},
	{
		'DataType': 'discography',
		'discographyID': 'Jimmy',
		'imageURL':'/media/discography/JimmyCover-min.png',
		
		'Externals': {
			
		},
		'NavigationStyle': {
			'primaryColor': 'rgb(81,75,107, 0.7)',
			'secondaryColor': '#ffffff'
		}, 
		
		'ContentPageData': {
			'background': {
				'imageURL': '/media/discography/JimmyCover-min.png',
				'color': 'rgb(25,27,33)'
			},
			
			'board': {
				'title': 'Jimmy',
				'position': '',
				'type': '',
				'brief': 'Won\'t you please come home',
				'story': `

				
				
				
				`,
				'deliverables': ['Lyricist, producer, guitarist, pianist, vocalist '],
				'styles': {
					'buttonColor': 'rgba(81,75,107,0.3)',
					'buttonArrowColor': 'rgb(255,255,255)',
					'headerColor': '#ffffff',
					'backgroundColor': 'rgba(25,27,33,0.95)',
					'positionColor': '#ffffff',
					'titleColor': '#ffffff',
					'viewApplicationColor': '#ffffff',
					'typeColor':  '#ffffff',
					'briefColor': '#ffffff',
					'storyColor': '#ffffff',
					'skillColor': '#ffffff',
					'externalsColor': '#ffffff'
				}
				
			}
		}
	},
    {
		'DataType': 'discography',
		'discographyID': 'TimeMachine',
		'imageURL':'/media/discography/timemachine-min.jpeg',
		'WebsiteData': {
			'link':'https://leadfinder.app/',
		},
		'Externals': {
			'Listen on Spotify': 'https://open.spotify.com/track/4zlK83knNxftFoN47ANx0R?si=2efce23a47cd461d',
            'Listen on Apple Music': 'https://music.apple.com/us/album/time-machine-feat-andy-citrin/1739658234?i=1739658235'
		},
		'NavigationStyle': {
			'primaryColor': 'rgb(113,101,192, 0.7)',
			'secondaryColor': '#ffffff'
		}, 
		
		'ContentPageData': {
			'background': {
				'imageURL': '/media/discography/timemachine-min.jpeg',
				'color': 'rgb(113,101,192)'
			},
			'board': {
				'title': 'Time Machine',
				'position': '',
				'type': '',
				'brief': '...If I could have one super power?',
				'story': `
				Its an age old question that has most likely been around since the intersection of human imagination and language. I’ve considered the obvious choices: the ability to soar through the skies, or to vanish to another part of the world with a single thought. But I have an inclination that, overtime, these activities would become mundane. At one point, hopping on a bus ride to the next city over, or boarding a plane to a foreign country were miraculous feats for the human experience. But these experiences feel like commonplace now.   Since I was young I have always fascinated over the concept of time travel. I wondered what it would feel like to witness dinosaurs roam the Pangean plain. And watch the cataclysm that took their presence and left the Earth so abandoned and lonely. Or to scoure through endless pages in the halls of the Library of Alexandria before she was left to ash. How would it feel to watch Jimi Hendrixs play his first live show. Endless adventure

				Time Machine is a song about that endless adventure — and about the deeper, more personal longing hidden inside it.
				
				`,
				'deliverables': ['Lyricist, producer, guitarist, pianist, vocalist '],
				'styles': {
					'buttonColor': 'rgba(113,101,192,0.8)',
					'buttonArrowColor': 'rgb(255,255,255)',
					'headerColor': '#ffffff',
					'backgroundColor': 'rgba(158,180,106,0.95)',
					'positionColor': '#ffffff',
					'titleColor': '#ffffff',
					'viewApplicationColor': '#ffffff',
					'typeColor':  '#ffffff',
					'briefColor': '#ffffff',
					'storyColor': '#ffffff',
					'skillColor': '#ffffff',
					'externalsColor': '#ffffff'
				}
				
			}
		}
	},
    {
		'DataType': 'discography',
		'discographyID': 'SafePlace',
		'imageURL':'/media/discography/SafePlaceAlbumArtwork-min.png',
		'WebsiteData': {
			'link':'https://leadfinder.app/',
		},
		'Externals': {
			
		},
		'NavigationStyle': {
			'primaryColor': 'rgba(228,132,162,0.7)',
			'secondaryColor': '#ffffff'
		}, 
		
		'ContentPageData': {
			'background': {
				'imageURL': '/media/discography/SafePlaceAlbumArtwork-min.png',
				'color': 'rgb(249,213,118)'
			},
			'board': {
				'title': 'Safe Place',
				'position': '',
				'type': '',
				'brief': 'Love aint a dangerous place',
				'story': `
					I havent yet written the bio for this song yet. Because I cant figure out what to say about it. It needs more time...
				`,
				'deliverables': ['Lyricist, producer, guitarist, pianist, vocalist '],
				'styles': {
					'buttonColor': 'rgba(0,0,0,0.3)',
					'buttonArrowColor': 'rgb(255,255,255)',
					'headerColor': '#ffffff',
					'backgroundColor': 'rgba(228,132,162,0.95)',
					'positionColor': '#ffffff',
					'titleColor': '#ffffff',
					'viewApplicationColor': '#ffffff',
					'typeColor':  '#ffffff',
					'briefColor': '#ffffff',
					'storyColor': '#ffffff',
					'skillColor': '#ffffff',
					'externalsColor': '#ffffff'
				}
				
			}
		}
	},
	
]


